import i18n from '@/i18n';
import {PeriodeItem} from '@/types';
import dateService from '@/services/dateService'

/** Calcul des dates de grossessesse */
const dateGrossesseService = {
	//renvoi la date présumée accouchement au format dd/mm/yyyy
	datePresumeeAccouchement(dpg: string):string {
		//date presumee de grossesse + 9 mois
		var datePresumeeAccouchement = this.dpgDecodeeDate(dpg);
		if (datePresumeeAccouchement != null) {
			datePresumeeAccouchement.setMonth(datePresumeeAccouchement.getMonth()+9);
			return new Intl.DateTimeFormat().format(datePresumeeAccouchement);
		}
		return '';
	},
	//renvoi la dpg decodee en string
	dpgDecodee(dpg: string):string {
		try {
			//decodage date en base 64
			var dpgDec = decodeURIComponent(escape(window.atob(dpg)));
			return dpgDec;
		} catch (e) {
			return '';
		}
	},
	//renvoi la dpg decodee en Date
	dpgDecodeeDate(dpg: string):Date | null {
		var dpgDec = this.dpgDecodee(dpg);
		if (dpgDec != '') {
			return new Date(+dpgDec.substring(0,4), +dpgDec.substring(4,6)-1, +dpgDec.substring(6,8));
		}
		return null;
	},
	//renvoi la date depart decalee du nbmois et du nbjour
	dateDecalee(dpg: string,nbMois:number, nbJour:number):string {
		var dateCal = this.dpgDecodeeDate(dpg);
		if (dateCal != null) {
			dateCal.setMonth(dateCal.getMonth()+nbMois);
			dateCal.setDate(dateCal.getDate()+nbJour);
			return new Intl.DateTimeFormat().format(dateCal);
		}
		return '';
	},
	//renvoi l'index de la periode en cours de la grossesse
	indexMoisEnCours(dpg: string):number {
		var dateDuJour = new Date();
		var datePresumeeGrossesse = dateGrossesseService.dpgDecodeeDate(dpg);
		if (datePresumeeGrossesse != null) {
			var diff = dateService.diffInMonths(datePresumeeGrossesse, dateDuJour);
			//recuperation des periodes
			var periodes = i18n.t('components.maternite.subheader.periodes') as unknown as PeriodeItem[];
			//dans quelle periode est-on?
			for (let index = 0; index < periodes.length; index++) {
				const element = periodes[index];
				if (diff < element.moisMax) {
					return index;
				}
			}
		}

		return -1;
	},
	//renvoi le mois d'affichage a partir de l'index
	moisAffichage(dpg: string):number {
		var index = this.indexMoisEnCours(dpg);
		//recuperation des periodes
		var periodes = i18n.t('components.maternite.subheader.periodes') as unknown as PeriodeItem[];
		if (index >= 0 && index < periodes.length) {
			return periodes[index].moisAffichage;
		}
		return -1;
	}
};

export default dateGrossesseService;